import React from "react";

const Profile = ( props ) => {

  const colors = [
    '#CDDBFE',
    '#FCD9BD',
    '#AFECEF',
    '#F7CDFe',
  ]

  const getColor = ( alt ) => {
    const firstLetter = alt[0].toLowerCase();
    const alphabet = 'abcdefghijklmnopqrstuvwxyz';
  
    // Check if the first letter is an alphabet character
    if (alphabet.includes(firstLetter)) {
      const index = firstLetter.charCodeAt(0) - 'a'.charCodeAt(0);
      return colors[index % colors.length];
    }
  
    // Return a default color for non-alphabet characters
    return '#E3E4E4';
  } 

  const src = props.src ?? ''
  const srcset = props.srcset ?? ''
  const size = props.size ?? 'auto'
  const alt = props.alt ?? ''
  const radius = props.radius ?? 'normal'
  const isImage = !! src || !! srcset
  const bgColor = alt ? getColor( alt ) : '#CDDBFE'
  const color = props.color ?? '#444446'
  const className = props.className ?? ''; // Add className prop

  // Generate initials
  const initials = alt
    .split(' ')
    .map(word => word.charAt(0).toUpperCase())
    .join('')
    .substring(0, 4);

  return (
    <div className={`msync-avatar msync-avatar--${radius} ${className}`} style={{ width: `${size}`}}> {/* Add className to the div */}
      {
        isImage
        ? <img 
            className='msync-avatar__image'
            src={ src }
            alt={ alt } // Keep the full alt text for accessibility
            srcSet={ srcset }
          />
        : <span
            className='msync-avatar__image msync-avatar__image--is-fallback'
            style={{ backgroundColor: `${bgColor}`, color: `${color}` }}>
            { initials } {/* Display initials as fallback */}
          </span>
      }
    </div>
  )

}

export default Profile
